import Vue from 'vue';
import FileSaver from 'file-saver';
import format from 'date-fns/format';

export const tesEmployeesListingService = {
  async retrieveTesEmployees(activeInactive, sortOrder, paginationParameters, searchParam) {
    return Vue.axios
      .get('/tes-employees/list', {
        params: {
          activeInactive,
          ...sortOrder,
          ...paginationParameters,
          searchParam
        }
      })
      .then(response => response.data);
  },

  async retrieveRecordCount(activeInactive, searchParam) {
    return Vue.axios
      .get('/tes-employees/count-records', {
        params: {
          activeInactive,
          searchParam
        }
      })
      .then(response => response.data);
  },

  async downloadAllTesEmployeesXlsx(activeInactive, sortOrder, searchParam) {
    const response = await Vue.axios({
      url: `/tes-employees/all/xlsx`,
      method: 'GET',
      params: {
        activeInactive,
        ...sortOrder,
        searchParam
      },
      responseType: 'blob'
    });

    FileSaver.saveAs(
      response.data,
      `AllTes-employees-${format(new Date(), 'YYYY-MM-DD-HH-mm-ss')}.xlsx`
    );
  },

  async downloadCurrentTesEmployeesXlsx(
    activeInactive,
    sortOrder,
    paginationParameters,
    searchParam
  ) {
    const response = await Vue.axios({
      url: `/tes-employees/xlsx`,
      method: 'GET',
      params: {
        activeInactive,
        ...sortOrder,
        ...paginationParameters,
        searchParam
      },
      responseType: 'blob'
    });

    FileSaver.saveAs(
      response.data,
      `tes-employees-${format(new Date(), 'YYYY-MM-DD-HH-mm-ss')}.xlsx`
    );
  }
};
